module.exports = __webpack_public_path__ + "static/img/CY@3x.d4dda851.png";